// src/components/UI/components/DropdownMenu/DropdownMenuTrigger.tsx

import { Trigger } from '@radix-ui/react-dropdown-menu';

export const DropdownMenuTrigger = Trigger;
DropdownMenuTrigger.displayName = 'DropdownMenuTrigger';
